// @module Tavanoteam.CustomerEventRegistration.CustomerEventRegistration
define('Tavanoteam.CustomerEventRegistration.CustomerEventRegistration.View'
,	[
		'tavanoteam_customereventregistration_customereventregistration.tpl'
	,	'Tavanoteam.CustomerEventRegistration.CustomerEventConfirmation.View'
	,	'Tavanoteam.CustomerEventRegistration.CustomerEventRegistration.ValidationMessage.View'
	,	'Tavanoteam.CustomerEventRegistration.CustomerEventRegistration.Model'

	,	'Backbone'
	,	'Utils'
	,	'jQuery'
	,	'underscore'
    ]
, function (

		tavanoteam_customereventregistration_customereventregistration_tpl
	,	CustomerEventConfirmationView
	,	CustomerEventRegistrationValidationMessageView
	,	CustomerEventRegistrationModel

	,	Backbone
	,	Utils
	,	jQuery
	,	_
)
{
    'use strict';

	// @class Tavanoteam.CustomerEventRegistration.CustomerEventRegistration.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavanoteam_customereventregistration_customereventregistration_tpl

	,	initialize: function (options) {

			Backbone.View.prototype.initialize.apply(this, arguments);

			var self = this;
			
			//Customer Event Registration Model
			this.model = new CustomerEventRegistrationModel();

			//Get Options
			this.container = options.container;
			this.layout = this.container.getComponent('Layout');

			//Get Configuration
			this.getEventRegistrationHeading = SC.CONFIGURATION.TTCustomerEventRegistration.eventRegistrationHeading;
			this.getEventDetailsHeading = SC.CONFIGURATION.TTCustomerEventRegistration.eventDetailsHeading;
			this.getEventDescriptionHeading = SC.CONFIGURATION.TTCustomerEventRegistration.eventDescriptionHeading;
			this.getEventButtonText = SC.CONFIGURATION.TTCustomerEventRegistration.eventButtonText;
			this.getDefaultEmail = SC.CONFIGURATION.TTCustomerEventRegistration.eventDefaultEmail;

			this.getDisableEventRegistration = !!SC.CONFIGURATION.TTCustomerEventRegistration.disableEventRegistration;
			this.getDisableEventMessage = SC.CONFIGURATION.TTCustomerEventRegistration.disableEventMessage || '<p>Registration is temporarily unavailable and users should call their branch.</p>'; 

			//Get Events Details
			this.eventId = this.eventId ? this.eventId : '';
			self.getEventsDetails();
			
		}

	//  **** Fetch Events Details ****

	, 	getEventsDetails: function () {

			var self = this;
			var eventId = this.eventId;

			this.model.fetch({ data: { eventId: eventId } }).done(function (result) {
				self.eventDetails = result;
				self.render();
			});
			
		}

	,	events: {
			'change [data-action="changeEvent"]': 'changeEvent',
			'click #submit-event-registration': 'registerEvent',
			'focusout #companyName': 'removeError',
			'focusout #contactName': 'removeError',
			'focusout #contactEmail': 'removeError',
			'focusout #contactPhone': 'removeError',
			'focusout #attendees': 'removeError',
			'focusout #trainingReferral': 'removeError',
			'focusout #eventAttendanceType': 'removeError',
			'focusout [name="contactPhone"]': 'validatePhone',
			'focusout [name="contactEmail"]': 'validateEmail'
		}
		
	,	changeEvent: function(e) {

			var $element = this.$(e.target),
			eventField = $element.parent().find('select'),
			eventValue = eventField.val();

			this.eventId = eventValue;
			this.getEventsDetails();

		}

	,	registerEvent: function() {
		
			var self = this;
			var promise = jQuery.Deferred();

			//Get Input Values
			var eventName = this.$("#eventName").val();
			var companyName = this.$("#companyName").val();
			var contactName = this.$("#contactName").val();
			var contactPhone = this.$("#contactPhone").val();
			var contactEmail = this.$("#contactEmail").val();
			var attendees = this.$("#attendees").val();
			var trainingReferral = this.$("#trainingReferral").val();
			var eventAttendanceType = this.$("#eventAttendanceType").val();
			var comments = this.$("#comments").val();

			var submitForm = eventName && companyName && contactName && contactEmail && contactPhone && attendees && trainingReferral && eventAttendanceType;

			//Show Error Message If Value is Blank

			if (!eventName) {

				var errorCode = 'ERR_EVENT_REGISTRATION_EVENT_BLANK';
				var message = 'Please select an Event.';
				var element = '.event-name-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#eventName').prev('label');
				Utils.animatedScroll(inputEl);

			}

			if (!companyName) {

				var errorCode = 'ERR_EVENT_REGISTRATION_COMPANY_NAME_BLANK';
				var message = 'Please enter value for Company Name.';
				var element = '.companyname-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#companyName').prev('label');
				Utils.animatedScroll(inputEl);

			}

			if (!contactName) {

				var errorCode = 'ERR_EVENT_REGISTRATION_CONTACT_NAME_BLANK';
				var message = 'Please enter value for Contact Full Name.';
				var element = '.contactname-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#contactName').prev('label');
				Utils.animatedScroll(inputEl);

			}

			if (!contactEmail) {

				var errorCode = 'ERR_EVENT_REGISTRATION_EMAIL_BLANK';
				var message = 'Please enter value for Contact Email.';
				var element = '.contactemail-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#contactEmail').prev('label');
				Utils.animatedScroll(inputEl);

			}

			if (!contactPhone) {

				var errorCode = 'ERR_EVENT_REGISTRATION_PHONE_BLANK';
				var message = 'Please enter value for Contact Phone.';
				var element = '.contactphone-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#contactPhone').prev('label');
				Utils.animatedScroll(inputEl);
				
			}

			if (!attendees) {

				var errorCode = 'ERR_EVENT_REGISTRATION_ATTENDEES_BLANK';
				var message = 'Please enter number of Attendees.';
				var element = '.attendees-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#attendees').prev('label');
				Utils.animatedScroll(inputEl);

			}
			
			if (!trainingReferral) {

				var errorCode = 'ERR_EVENT_REGISTRATION_TRAININGREFERRAL_BLANK';
				var message = 'Please enter number of Training Referral.';
				var element = '.training-referral-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#trainingReferral').prev('label');
				Utils.animatedScroll(inputEl);

			}

			if (!eventAttendanceType) {

				var errorCode = 'ERR_EVENT_REGISTRATION_EVENTATTENDANCETYPE_BLANK';
				var message = 'Please enter value for Event Attendance Type.';
				var element = '.eventattendancetype-error-message';
				this.displayError(errorCode, message, element);

				var inputEl = this.$('#eventAttendanceType').prev('label');
				Utils.animatedScroll(inputEl);

			}

			if (submitForm) {

				//Validation Phone and Email
				var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

				var invalidEmail = contactEmail && !emailReg.test(contactEmail);
				var invalidPhone = contactPhone && contactPhone.length < 7;

				if (invalidEmail || invalidPhone) {

					if (invalidEmail) {

						var errorCode = 'ERR_EVENT_REGISTRATION_EMAIL_INVALID';
						var message = 'Please enter a valid email address.';
						var element = '.contactemail-error-message';
						this.displayError(errorCode, message, element);

						var inputEl = this.$('#contactEmail').prev('label');
						Utils.animatedScroll(inputEl);
		
					}

					if (invalidPhone) {

						var errorCode = 'ERR_EVENT_REGISTRATION_PHONEL_INVALID';
						var message = 'Phone number should have seven digits or more.';
						var element = '.contactphone-error-message';
						this.displayError(errorCode, message, element);

						var inputEl = this.$('#contactPhone').prev('label');
						Utils.animatedScroll(inputEl);
	
					}

				}

				else {

					//Save Record
					var eventRegistrationModel = new CustomerEventRegistrationModel();
					eventRegistrationModel.set("companyName", companyName);
					eventRegistrationModel.set("contactName", contactName);
					eventRegistrationModel.set("contactPhone", contactPhone);
					eventRegistrationModel.set("contactEmail", contactEmail);
					eventRegistrationModel.set("attendees", attendees);
					eventRegistrationModel.set("trainingReferral", trainingReferral);
					eventRegistrationModel.set("eventAttendanceType", eventAttendanceType);
					eventRegistrationModel.set("comments", comments);
					eventRegistrationModel.set("eventName", eventName);
					eventRegistrationModel.save().then(function(response) {

						if (response) {

							//Display Confirmation Page in Modal
							var view = new CustomerEventConfirmationView({
								container: self.container,
								eventName: self.getEventName,
								eventVendorBtnName: self.getEventVendorBtnName,
								eventVendorBtnLink: self.getEventVendorBtnLink 
							});
							self.layout.showContent(view, { showInModal: true});

							//Clear All Fields
							self.render();

						}

					}).fail(function(e) {
						var a = e;
					});
				}
				
			}

		}

	,	validatePhone: function(e) {

		var $element = this.$(e.target),
		elementId = $element.attr('id'),
		getField = $element.parent().find('input#'+ elementId),
		getValue = getField.val();
 
		if (getValue.length !== 0 && getValue.length < 7) {

			var errorCode = 'ERR_EVENT_REGISTRATION_PHONEL_INVALID';
			var message = 'Phone number should have seven digits or more.';
			var element = '.contactphone-error-message';
			this.displayError(errorCode, message, element);

		}
		else {
			this.$('.contactphone-error-message').hide();
		}

	}

	,	validateEmail: function(e) {

		var $element = this.$(e.target),
		elementId = $element.attr('id'),
		getField = $element.parent().find('input#'+ elementId),
		getValue = getField.val();
 
		var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	
		if (!emailReg.test(getValue)) {

			var errorCode = 'ERR_EVENT_REGISTRATION_EMAIL_INVALID';
			var message = 'Please enter a valid email address.';
			var element = '.contactemail-error-message';
			this.displayError(errorCode, message, element);
			
		}
		else {
			this.$('.contactemail-error-message').hide();
		}

	}

	,	displayError: function(errorCode, message, element) {
				
			var messageView = new CustomerEventRegistrationValidationMessageView({
				errorCode: errorCode,
				message: message,
				type: 'error',
				closable: true
			});
			
			this.$(element).show();
			this.$(element).html(messageView.render().$el);

	}

	,	removeError: function(e) {
		var $element = this.$(e.target),
			elementId = $element.attr('id'),
			getValue = $('#'+ elementId).val();

		if (getValue) {

			if (elementId == "eventName") {
				this.$('.event-name-error-message').hide();
			}
			if (elementId == "companyName") {
				this.$('.companyname-error-message').hide();
			}
			if (elementId == "contactName") {
				this.$('.contactname-error-message').hide();
			}
			if (elementId == "contactEmail") {
				this.$('.contactemail-error-message').hide();
			}
			if (elementId == "contactPhone") {
				this.$('.contactphone-error-message').hide();
			}
			if (elementId == "attendees") {
				this.$('.attendees-error-message').hide();
			}
			if (elementId == "trainingReferral") {
				this.$('.training-referral-error-message').hide();
			}
			if (elementId == "eventAttendanceType") {
				this.$('.eventattendancetype-error-message').hide();
			}

		}

	}

		//@method getContext @return Tavanoteam.CustomerEventRegistration.CustomerEventRegistration.View.Context
	,	getContext: function getContext()
		{
			//@class Tavanoteam.CustomerEventRegistration.CustomerEventRegistration.View.Context

			var self = this;

			//Get Event Details
			this.eventDetails = this.eventDetails || [];

			//If Event is selected
			var eventSelected = this.$("#eventName").val();

			//Get Event ID URL Parameter
			this.eventIDParams = '';
			this.eventIDParamsValid = false;
			if (this.options.routerArguments && this.options.routerArguments[0]) {
				var params = Utils.parseUrlOptions(this.options.routerArguments[0]);
				if (params.event) {
					this.eventIDParams = params.event;
				}
			}

			//Get Events Details
			var getEventDetails = [];
			_.each(self.model.get("0"), function(events){
				_.each(events, function(event){
				getEventDetails.push(event);
				});
			});

			//Get Attendees Options
			var getAttendeesOptions = [];
			_.each(self.model.get("1"), function(attendeeOption){
				_.each(attendeeOption, function(value){
					getAttendeesOptions.push(value);
				});
			});
			
			//Get Training Referral Options
			var getTrainingReferralOptions = [];
			_.each(self.model.get("3"), function(trainingReferralOption){
				_.each(trainingReferralOption, function(value){
					getTrainingReferralOptions.push(value);
				});
			});

			//Get Training Referral Options
			var getEventAttendanceTypeOptions = [];
			_.each(self.model.get("4"), function(eventAttendanceTypeOption){
				_.each(eventAttendanceTypeOption, function(value){
					getEventAttendanceTypeOptions.push(value);
				});
			});
			
			//Get Events Options
			var getEventOptions = [];
			_.each(self.model.get("2"), function(eventOption){
				_.each(eventOption, function(value){
					//If Event is selected
					if (eventSelected) {
						if (eventSelected == value.id) {
							value.isSelected = 'selected';
						}
					}
					//If Event ID Parameter is not null
					else if (self.eventIDParams) {
						if (self.eventIDParams == value.id) {
							value.isSelected = 'selected';
							self.eventIDParamsValid = true;
						}
					}
					getEventOptions.push(value);
				});
			});

			if (eventSelected || this.eventIDParamsValid) {

				//Get Event ID Parameter Oprtion Details
				if (this.eventIDParamsValid) {
					getEventDetails = getEventDetails.filter(function (option) {
						return option.eventInternalId == self.eventIDParams;
					});
				}

				//Get First Event Option Details
				var firstEventOption;

				if (getEventDetails.length > 1) {
					firstEventOption = getEventDetails.filter(function(i){
						return i.eventInternalId == getEventOptions[0].id;
					});
				}
				else {
					firstEventOption = getEventDetails;
				}
			}
		
			//Get Event Details
			var getEventDate = _.map(firstEventOption, function (result) { return result.eventDate;});
			var getEventTime = _.map(firstEventOption, function (result) { return result.eventTime;});
			var getEventAddress = _.map(firstEventOption, function (result) { return result.eventAddress;});
			var getEventEmail = _.map(firstEventOption, function (result) { return result.eventEmail;});
			var getEventPhone = _.map(firstEventOption, function (result) { return result.eventNumber;});
			var _getEventDescription = _.map(firstEventOption, function (result) { return result.eventDescription;});
			var getEventDescription = _getEventDescription.toString().replace(/(?:\r\n|\r|\n)/g, '</br>');
			var getEventFlyer = _.map(firstEventOption, function (result) { return result.eventFlyerLink;});

			//Pass to Confirmation
			var getEventName = _.map(firstEventOption, function (result) { return result.eventName;});
			var getEventVendorBtnName = _.map(firstEventOption, function (result) { return result.eventVendorBtnName;});
			var getEventVendorBtnLink = _.map(firstEventOption, function (result) { return result.eventVendorBtnLink;});

			this.getEventName = getEventName[0] ? getEventName[0] : '';
			this.getEventVendorBtnName = getEventVendorBtnName[0] ? getEventVendorBtnName[0] : '';
			this.getEventVendorBtnLink = getEventVendorBtnLink[0] ? getEventVendorBtnLink[0] : '';

			//Other Template Variables
			var hasEventDetails = getEventDetails.length > 0 ? true : false;
			var hasDescription = getEventDescription !== '' ? true : false;
			var hasEventSelected = eventSelected || this.eventIDParamsValid == true ? true : false;
		
			return {
				hasEventDetails: hasEventDetails,
				hasDescription: hasDescription,
				hasEventSelected: hasEventSelected,
				eventOptions: getEventOptions ? getEventOptions : [],
				attendeesOptions: getAttendeesOptions ? getAttendeesOptions : [],
				trainingReferralOptions: getTrainingReferralOptions ? getTrainingReferralOptions : [],
				eventAttendanceTypeOptions: getEventAttendanceTypeOptions ? getEventAttendanceTypeOptions : [],
				eventDate: getEventDate[0] ? getEventDate[0] : '',
				eventTime: getEventTime[0] ? getEventTime[0] : '',
				eventAddress: getEventAddress[0] ? getEventAddress[0] : '',
				eventEmail: getEventEmail[0] ? getEventEmail[0] : '',
				eventNumber: getEventPhone[0] ? getEventPhone[0] : '',
				eventFlyerLink: getEventFlyer[0] ? getEventFlyer[0] : '',
				eventButtonText: this.getEventButtonText ? this.getEventButtonText : 'Register Now',
				eventDefaultEmail: this.getDefaultEmail ? this.getDefaultEmail : '',
				eventRegistrationHeading: this.getEventRegistrationHeading ? this.getEventRegistrationHeading : 'Event Registration',
				eventDescription: getEventDescription ? getEventDescription : '',
				eventDetailsHeading: this.getEventDetailsHeading ? this.getEventDetailsHeading : 'Event Details',
				eventDescriptionHeading: this.getEventDescriptionHeading ? this.getEventDescriptionHeading : 'About',
				disableEventRegistration: this.getDisableEventRegistration ? this.getDisableEventRegistration : false,
				disableEventMessage: this.getDisableEventMessage ? this.getDisableEventMessage : ''
			};
		}
	});
});
